import { setSuccessfullModifyDialog } from '../redux/successfullModifyDialogSlice';
import { Dialog, DialogContent, Typography, Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Iconify from './Iconify';
import '../css/successfullModifyDialog.css';

export const SuccessfullModifyDialog = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const successfullModify = useSelector((state) => state.SuccessfullModifyDialog);

    const handleClose = () => {
        dispatch(setSuccessfullModifyDialog({ open: false, type: '' }));
    };

    useEffect(() => {
        if (successfullModify.open) {
            setTimeout(() => {
                handleClose();
            }, 2000);
        }
    });

    return (
        <Dialog open={successfullModify?.open} onClose={() => handleClose()} fullWidth>
            <Box onClick={handleClose} className='SuccessfullModify_icon_text'>
                <Typography className='SuccessfullModify_title'>{successfullModify?.type}</Typography>
                <Iconify icon="material-symbols:close" className='SuccessfullModify_close_icon' />
            </Box>
            <DialogContent className='SuccessfullModify_dialog_content' >
                <Iconify icon="lets-icons:check-ring-light" className='SuccessfullModify_check_icon' />
                <Typography className='SuccessfullModify_message'>{t('Modifications enregistrées avec succès')}</Typography>
            </DialogContent>
        </Dialog>
    );
};